// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9041 ? "526adfa3" : chunkId) + "." + {"2177":"b137444571d23e87","3594":"28fc7f1024bb5e3e","3618":"d6859cdf06e610bc","9041":"314a44764e61800f"}[chunkId] + ".js";
};